import http from 'hub-http/clients/apiClient';
import TagRecord from '../records/TagRecord';
import { getShouldCallSCPEndpoints } from '../migration-handler/singleton/migrationHandler';
const API_BASE = '/knowledge-content/v1/tags';
const SCP_API_BASE = '/knowledge-content/v2/tags';

// to include only needed properties for TagRecord
const ALLOWED_TAG_RECORD_PROPERTIES = Object.keys(new TagRecord().toJS());
export default class TagsApi {}
TagsApi.get = knowledgeBaseId => {
  const isOnSCP = getShouldCallSCPEndpoints(knowledgeBaseId);
  if (!isOnSCP) {
    return http.get(`${API_BASE}/list`, {
      query: {
        property: ALLOWED_TAG_RECORD_PROPERTIES,
        limit: 5000,
        sort: 'name',
        contentGroupId: knowledgeBaseId
      }
    });
  }
  return http.get(SCP_API_BASE, {
    query: {
      knowledgeBaseIds: [knowledgeBaseId]
    }
  });
};
TagsApi.update = (tagId, tagData) => {
  const isOnSCP = getShouldCallSCPEndpoints(tagData.knowledgeBaseId);
  if (!isOnSCP) {
    return http.put(`${API_BASE}/${tagId}`, {
      data: tagData
    });
  }
  return http.post(`${SCP_API_BASE}/upsert-and-assign`, {
    data: {
      id: tagId,
      name: tagData.name,
      knowledgeBaseId: tagData.knowledgeBaseId,
      articleIds: tagData.contentIds
    }
  }).then(payload => Object.assign({}, payload.tag, {
    contentIds: payload.articleIds
  }));
};
TagsApi.create = ({
  name,
  contentIds,
  knowledgeBaseId
}) => {
  const isOnSCP = getShouldCallSCPEndpoints(knowledgeBaseId);
  if (!isOnSCP) {
    return http.post(API_BASE, {
      data: {
        name,
        contentIds,
        knowledgeBaseId
      }
    });
  }
  return http.post(`${SCP_API_BASE}/upsert-and-assign`, {
    data: {
      name,
      knowledgeBaseId,
      articleIds: contentIds
    }
  }).then(payload => Object.assign({}, payload.tag, {
    contentIds: payload.articleIds
  }));
};